module.exports = __webpack_public_path__ + "img/logo priority-13.b93f70aa.png";